import React from 'react';
import Logo from './Logo';
import ClickMark from './ClickMark';
import {IconArrowRight,IconStar,IconCalendar,IconMessageSquare} from './Icons';
import {BOOK_URL,PACKAGES} from '../siteConfig';

const links=['Conversations','Contacts','Bookings','Reviews','Payments'];

function MiniDashboard() {
  return (
    <div className="dashboard">
      <div className="dash-sidebar">
        <span className="mini-logo-img"><Logo /></span>
        {links.map((name,index)=> (
          <span className={index===0 ? 'dash-link active' : 'dash-link'} key={name}>{name}</span>
        ))}
      </div>
      <div className="dash-main">
        <div className="dash-heading"><b>Good morning, Alex</b><span>Today</span></div>
        <div className="metric-grid">
          <div className="metric lavender"><IconMessageSquare /><b>3</b><span>Missed calls texted back</span></div>
          <div className="metric peach"><IconStar /><b>4.9</b><span>Review rating</span></div>
          <div className="metric blue"><IconCalendar /><b>5</b><span>Bookings</span></div>
        </div>
        <div className="activity-card">
          <span><i className="status-dot" /> New lead from website</span><b>Replied in 8s</b>
          <span><i className="status-dot yellow-dot" /> Review request</span><b>Sent</b>
          <span><i className="status-dot blue-dot" /> Invoice #1042</span><b>Paid</b>
        </div>
      </div>
    </div>
  );
}

function Hero() {
  return (
    <section className="hero" id="top">
      <div className="hero-copy reveal">
        <span className="eyebrow"><i /> Done-for-you tech for local businesses</span>
        <h1>
          Never miss a customer. <em>We handle the tech.</em>
          <ClickMark className="h1-mark" color="#caa1eb" />
        </h1>
        <p>
          Missed calls get a text back. New leads get a reply in seconds. Bookings, reminders, reviews and payments run on their own. We set it all up, connect it to your phone and website, and keep it running, so you can get back to the work you actually enjoy.
        </p>
        <div className="hero-actions">
          <a className="primary-button" href={BOOK_URL}>Book a free call <IconArrowRight /></a>
          <a className="text-button" href="#/services">See all services</a>
        </div>
        <span className="reassurance">
          Packages from ${PACKAGES[0].price}/month · No long-term contracts · Local to Surprise, AZ
        </span>
      </div>
      <div className="hero-visual reveal reveal-d">
        <MiniDashboard />
        <ClickMark className="float-mark fm-a" color="#f7a38c" />
        <ClickMark className="float-mark fm-b" color="#94b6e8" />
        <div className="floating-card">
          <span>Missed call, 2:14 PM</span>
          <b>“Sorry we missed you! How can we help?”</b>
          <small>Texted back in 5 seconds.</small>
        </div>
      </div>
    </section>
  );
}

export default Hero;
